module.exports = __webpack_public_path__ + "static/media/FileImage.3636a2ce.svg";